<template>
    <div name="easy-service" class="easy-service">
        <div class="container">
            <div class="section-header">
                <strong class="title">모두를 위한<br>간편하고 안전한 서비스</strong>
                <p class="sub-text">
                    보호자는 진료 전 후, 복약 안내 등 모든 과정을<br>
                    전자 문서를 통해 언제 어디서든 확인 가능합니다.</p>
            </div>
            <div class="service-view">
                <div class="carousel-container">
                    <carousel :autoplay="true" :loop="true" :paginationEnabled="false" :autoplay-timeout="5000" :perPage="1" @after-change="onSlideChange"  @page-change="onSlideChange" ref="carousel">
                        <slide v-for="(image, index) in images" :key="index">
                            <img :src="image" alt="모두를 위한 간편하고 안전한 서비스 이미지" class="img-slide"/>
                        </slide>
                    </carousel>
                    <div class="dot-container">
                        <span @click="goToSlide(0)" :class="{ 'active': currentSlide === 0 }"></span>
                        <span @click="goToSlide(1)" :class="{ 'active': currentSlide === 1 }"></span>
                        <span @click="goToSlide(2)" :class="{ 'active': currentSlide === 2 }"></span>
                    </div>

                    <div class="custom-arrows">
                        <button type="button" class="arrow-prev" @click="goToPrevSlide"><span class="ico ico-left">이전</span></button>
                        <button type="button" class="arrow-next" @click="goToNextSlide"><span class="ico ico-right">다음</span></button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
    name: 'easy-service',
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            images: [
                require('../../assets/mobile_barocare/img_slider1.png'),
                require('../../assets/mobile_barocare/img_slider2.png'),
                require('../../assets/mobile_barocare/img_slider3.png'),
            ],
            activeIndex: 0,
            currentSlide: 0,
            carouselRef: null,
        };
    },
    mounted() {
        this.$nextTick(() => {
            const carouselWrapper = this.$refs.carousel.$el.querySelector
                                (
                                    '.VueCarousel-wrapper'
                                );
            if (carouselWrapper) {
                carouselWrapper.style.overflow = 'visible';
            }
        });
    },
    methods: {
        goToSlide(index) {
            this.currentSlide = index;
            this.$refs.carousel.goToPage(index);
        },
        onSlideChange(index) {
            this.currentSlide = index;
        },
        goToPrevSlide() {
            const currentPage = this.$refs.carousel.currentPage;

            if (currentPage > 0) {
                const targetPage = currentPage - 1;
                this.$refs.carousel.goToPage(targetPage);
            }
        },
        goToNextSlide() {
            const currentPage = this.$refs.carousel.currentPage;
            const totalPages = this.$refs.carousel.pageCount;

            if (currentPage < totalPages - 1) {
                const targetPage = currentPage + 1;
                this.$refs.carousel.goToPage(targetPage);
            }
        },
    },
}
</script>

<style scoped>
    .easy-service {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 100%;
        background: #EBF7FE;
    }
    .easy-service .container{
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        width: 100%;
        height: 959px;
        margin: 0 auto;
        padding: 120px 20px 40px;
        z-index: 1;
    }
    .section-header{
        width: 100%;
        font-family: 'Pretendard';
        font-style: normal;
        text-align: center;
    }
    .section-header .title{
        font-size: 32px;
        font-weight: 600;
        line-height: 1.35;
        color: #1A1A1A;
    }
    .section-header .sub-text{
        margin-top: 15px;
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 400;
        line-height: 1.65;
        color: #1A1A1A;
    }
    .sub-text strong{
        font-weight: 600;
    }
    .service-view{
        margin-top: 47px;
        width: 365px;
        height: 496px;
    }
    .carousel-container {
        position: relative;
        /* position: absolute; */
        /* left: 56%; */
        /* bottom: 0; */
        width: 100%;
        overflow: hidden;
    }
    .dot-container{
        height: 47px;
        margin-top: 27px;
        text-align: center;
    }
    .img-slide{
        width: 365px;
        height: 496px;
    }

    .dot-container span {
        display: inline-block;
        width: 10px;
        height: 10px;
        margin: 5px;
        background-color: #D9D9D9;
        border-radius: 50%;
        cursor: pointer;
    }

    .dot-container span.active {
        width: 34px;
        background-color: #0082EC;
        border-radius: 10px;
    }
    .custom-arrows{
        position: absolute;
        top: calc(50% + 17px);
        left: 0;
        right: 0;
        transform: translateY(-50%);
        display: flex;
        justify-content: space-between;
    }

    .arrow-prev{
        left: 17px;
        background: url(../../assets/mobile_barocare/ico-chevron-left.png);
        background-position: center center;
        background-size: 28px auto;
    }
    .arrow-next{
        right: 17px;
        background: url(../../assets/mobile_barocare/ico-chevron-right.png);
        background-position: center center;
        background-size: 28px auto;
    }
    .arrow-prev,
    .arrow-next {
        position: absolute;
        transform: translateY(-50%);
        width: 28px;
        height: 31px;
        text-indent: -9999px;
        cursor: pointer;
        z-index: 10;
        border: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_barocare/EasyService.vue